export const LOAD_SYSTEM_MESSAGES = 'LOAD_SYSTEM_MESSAGES'
export const LOAD_SYSTEM_MESSAGES_SUCCESS = 'LOAD_SYSTEM_MESSAGES_SUCCESS'
export const LOAD_SYSTEM_MESSAGES_FAILED = 'LOAD_SYSTEM_MESSAGES_FAILED'

export const PUT_SYSTEM_MESSAGE_STATUS = 'PUT_SYSTEM_MESSAGE_STATUS'
export const PUT_SYSTEM_MESSAGE_STATUS_SUCCESS = 'PUT_SYSTEM_MESSAGE_STATUS_SUCCESS'
export const PUT_SYSTEM_MESSAGE_STATUS_FAILED = 'PUT_SYSTEM_MESSAGE_STATUS_FAILED'
